import { render, staticRenderFns } from "./Amazontimeline.vue?vue&type=template&id=3d5c332e&scoped=true&"
import script from "./Amazontimeline.vue?vue&type=script&lang=js&"
export * from "./Amazontimeline.vue?vue&type=script&lang=js&"
import style0 from "./Amazontimeline.vue?vue&type=style&index=0&id=3d5c332e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5c332e",
  null
  
)

export default component.exports